import Raven from 'raven-js';
import ACBadRequestError from './ACBadRequestError';
import ACMissingContentError from './ACMissingContentError';
import ACForbiddenError from './ACForbiddenError';
import { useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ApiError = ({
  error
}) => {
  const status = error && typeof error !== 'string' && (error.status || error.networkError && error.networkError.status) || 404;
  useEffect(() => {
    if (![404, 403].includes(status)) {
      Raven.captureException(error);
    }
  }, [error, status]);
  switch (status) {
    case 404:
      return /*#__PURE__*/_jsx(ACMissingContentError, {});
    case 403:
      return /*#__PURE__*/_jsx(ACForbiddenError, {});
    default:
      return /*#__PURE__*/_jsx(ACBadRequestError, {});
  }
};
export default ApiError;